import { Box, Typography } from '@mui/material';
import { UsersSection } from './UsersSection';

/** `/admin/users` — everyone who has signed in, and who is an admin. */
export const AdminUsersPage = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography variant="h1" component="h1">
        Users
      </Typography>
      <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: 720 }}>
        Everyone in the user pool, with when each last signed in where that is recorded. An admin can make someone an admin, or remove that. A change
        reaches their session when it next issues tokens.
      </Typography>
    </Box>

    <UsersSection />
  </Box>
);
